"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var link_1 = require("spry-react/Link/link");
var Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    function Breadcrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumb.prototype.render = function () {
        var classes = classNames({
            'breadcrumb': true,
            'breadcrumb-no-left-padding': this.props.hasNoLeftPadding,
            'half-pin': this.props.halfPin
        });
        return React.createElement("div", __assign({ className: classes }, (this.props.pinAfterScrollingPx && { 'data-pin-on-scroll': this.props.pinAfterScrollingPx })),
            React.createElement(link_1.Link, { className: "icon back-icon", url: !isOnClickProps(this.props) ? this.props.url : undefined, onClick: isOnClickProps(this.props) ? this.props.onClick : null, title: this.props.text },
                React.createElement("span", { className: classNames("breadcrumb-text", this.props.hideBreadCrumbTextWhenPinned && "breadcrumb-text-hidden-when-pinned") }, this.props.text)));
    };
    return Breadcrumb;
}(React.Component));
exports.Breadcrumb = Breadcrumb;
function isOnClickProps(props) {
    var _a;
    return !!((_a = props) === null || _a === void 0 ? void 0 : _a.onClick);
}
